import React from "react";
import { filterValidCta } from "@qlik/qlik/src/lib/util/helpers";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import * as styles from "./styles.module.css";
/**
 * QuoteWithImage component
 * This component renders a quote with an image.
 * @param {Object} data - The data for the quote.
 */
const QuoteWithImage = ({ data }) => {
    // Destructure the data object
    const { cardItem, customId, backgroundColor, backgroundImage, additionalConfiguration, id } = data ?? {};
    const { title, subtitle, media, cta } = cardItem ?? {};
    // Filter valid CTAs
    const ctaList = filterValidCta(cta);
    // Get the spacing class name based on the additional configuration
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-20");
    // Get the color class name based on the background color
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section
            id={customId ?? id}
            data-section="true"
            className={`scroll-mt-45 relative isolate overflow-hidden ${sectionSpacingClassName} ${sectionColorMapping.bgColor}`}
        >
            <div className="container xl:relative flex flex-wrap items-center gap-7.5 lg:flex-nowrap lg:gap-15">
                {/* Render the background image if it exists */}
                {backgroundImage?.length > 0 && backgroundImage?.[0]?.resource_type === "image" && (
                    <div className={`${styles.bgImage} absolute -z-1`}>
                        <Media
                            key={backgroundImage?.[0]?.id}
                            link={backgroundImage?.[0]?.secure_url}
                            width={backgroundImage?.[0]?.width}
                            height={backgroundImage?.[0]?.height}
                            className="h-full object-contain"
                        />
                    </div>
                )}
                {/* Render the media if it exists */}
                {media?.[0] && (
                    <div className="overflow-hidden rounded md:flex-1 lg:min-w-[627px]">
                        <Media media={media[0]} className="w-full h-full object-cover" />
                    </div>
                )}
                <div className="md:flex-1 lg:pt-7">
                    {/* Render the title if it exists */}
                    {title && (
                        <h2
                            className={`${sectionColorMapping.primaryTextColor} font-6xl font-semibold leading-tight tracking-tight10 text-left relative`}
                        >
                            {title}
                        </h2>
                    )}
                    {/* Render the subtitle if it exists */}
                    {subtitle && (
                        <p className={`${sectionColorMapping.secondaryTextColor} font-md leading-snug tracking-tight4`}>
                            {subtitle}
                        </p>
                    )}
                    {/* Render the CTAs if they exist */}
                    {ctaList && ctaList.length > 0 && (
                        <div className="flex flex-wrap gap-3.75 mt-5 items-center justify-start lg:mt-7.75">
                            {ctaList.map((linkData) => (
                                <Cta key={linkData.id} className="text-md font-bold leading-none" data={linkData} />
                            ))}
                        </div>
                    )}
                </div>
            </div>
        </section>
    );
};

export default QuoteWithImage;
